export default "__VITE_ASSET__uNEe8Nuq__"